// eslint-disable-next-line import/prefer-default-export
export const globals = {
    juror: [],
    roles: [],
    sources: [],
    majors: [],
    recommendations: [],
    schools: []
};
